import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productionUnit',
    standalone: false
})
export class ProductionUnitFormatPipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

  public transform(value: number, isBagable: boolean): string {
    value = value || 0;

    if (!isBagable) {
      return `${formatNumber(value, this.locale, '1.0-0')} Stück`;
    }

    return `${formatNumber(value / 1000, this.locale)} kg`;
  }
}
